module.exports = __webpack_public_path__ + "static/img/Servicess-Outer-Stroke.07e2df5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Servicess-Outer-Stroke.jpg
// module id = BLJl
// module chunks = 1